export default "__VITE_ASSET__ohXfPQBO__"